function ImageIcon(props)
{
    return(
        <svg className={props.class} viewBox="-5.0 -10.0 110.0 135.0">
 <path d="m84.598 15.93h-69.172c-5.7422 0-10.426 4.6602-10.426 10.402v47.344c0 5.7422 4.6836 10.402 10.426 10.402h69.172c5.7148 0 10.402-4.6602 10.402-10.402v-47.348c0-5.7422-4.6836-10.402-10.402-10.402zm2.6797 41.328-16.969-16.262c-1.8555-1.7773-4.793-1.7305-6.5898 0.10547l-19.004 19.422c-0.33203 0.33984-0.86719 0.36719-1.2344 0.0625l-7.7422-6.4883c-1.75-1.4688-4.3047-1.457-6.043 0.023438l-16.973 14.438v-42.23c0-1.4922 1.2109-2.6758 2.7031-2.6758h69.172c1.4688 0 2.6758 1.1836 2.6758 2.6758v30.93z"/>
 <path d="m48.145 37.676c0 4.082-3.3047 7.3867-7.3867 7.3867-4.0781 0-7.3867-3.3047-7.3867-7.3867 0-4.0781 3.3086-7.3867 7.3867-7.3867 4.082 0 7.3867 3.3086 7.3867 7.3867z"/>
</svg>
    )
}

export default ImageIcon